<template>
  <div class="pa-1" style="text-align: center;">
    <svg width="30%" height="30%" viewBox="0 0 341 1095" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
      <g transform="matrix(1,0,0,1,-228.897,-258.962)">
        <path d="M341.177,896.323L341.175,896.325C341.175,896.325 281.783,916.526 246.154,928.645C241.373,930.271 236.083,928.993 232.571,925.364C229.059,921.736 227.955,916.407 229.736,911.681C267.777,810.774 407.322,440.615 472.617,267.413C474.923,261.298 481.394,257.83 487.762,259.297C494.13,260.763 498.432,266.712 497.831,273.219L456.85,716.567L456.851,716.565C456.851,716.565 516.243,696.364 551.872,684.246C556.653,682.62 561.944,683.897 565.456,687.526C568.968,691.155 570.072,696.484 568.291,701.209C530.25,802.116 390.704,1172.28 325.409,1345.48C323.104,1351.59 316.633,1355.06 310.265,1353.59C303.897,1352.13 299.594,1346.18 300.196,1339.67L341.177,896.323Z"
        :style="{fill: hexColor || '#000000'}"/>
      </g>
    </svg>
  </div>
</template>

<script>
  export default {
    name: 'LighteningBoltIndicater',
    props: ['hexColor'],

    data: () => ({
      boltColor: '#fecb39'
    }),
  }
</script>

<style scoped>
</style>